<template>
  <section class="section first_page">
    <div class="container-flud ">
      <loading-block v-if="is_load==false" :loading="!is_load"/>
      <div class="col-md-12 center-block d-flex justify-content-center loading_div " v-if="is_load==false">
        <h2>Идет загрузка...</h2>
      </div>
      <div   v-if="is_load">
        <common-user-page :user="user" :activeTab="'works'"/>
        <div class="mt-3 section_header_without_bg">
          <div class="col-12 col-md-10 mx-auto">
            <h4 >Информация о работе</h4>
            <p>Категория:{{ work.category.name }}</p>
            <p>Дата {{ work.date_start }} - {{ work.date_end }}</p>
          </div>
          <div class="col-12 col-md-10 col-lg-10 mt-3 mb-3 mx-auto ">






            <editorjsrender class="ml-3"  :align_style="'center'"  :blocks_json="work.json.blocks"></editorjsrender>


          </div>
        </div>






      </div>
    </div>
  </section>
</template>

<script>
import Api from "@/models/Api";
import LoadingBlock from "@/components/Custom/LoadingBlock";
import Vue from "vue";
import CommonUserPage from "@/components/user_page/CommonUserPage";
import PortfolioListUserPage from "@/components/user_page/PortfolioListUserPage";
import Editorjsrender from "@/models/Editorjsrender.vue";

export default {
  name: "UserPagePortfolio",
  data(){
    return {
      "is_load":false,
      'user':null,
      'work':null,
      "tags":[],
      'image_url':null,
    };
  },
  components: {LoadingBlock,CommonUserPage,PortfolioListUserPage,Editorjsrender},
  mounted: function () {
    var app=this;
    var id=this.$route.params.user_id;
    var work_id=this.$route.params.work_id;
    app.is_load=false;
    app.image_url = Vue.config.IMAGE_URL;
    app.loadMainData(id,work_id);
  },
  methods:{
    loadMainData(id,work_id){
      var app=this;
      Api.loadUserPageOnePortfolio(id,work_id,function(data){
        app.user=data.user;
        app.work=data.work;

        app.is_load=true;
      },function(error){
        if(error.response.data.code==404){
          app.$router.push({name:'404'});
        }
      });
    }
  }
}
</script>

<style scoped>

</style>